import React, { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import useCatalogue from "../../../services/Order/UseCatalogue";
import { GlobalContext } from "../../../Context/GlobalContext";
import useInventory from "../../../services/Inventory/useInventory";

const IngredientsPage = () => {
  const { addRecipeIngredient } = useCatalogue();
    const { getRecipeIngredients } = useInventory();

  const { userID } = useContext(GlobalContext);

  const location = useLocation();
  const item = location.state?.item;

  const [ingredients, setIngredients] = useState([]);

  const [formRows, setFormRows] = useState([
    { name: "", qty: "", unit: "" },
  ]);

  const [showForm, setShowForm] = useState(false);

  useEffect(() => {
    const loadData = async () => {
      const data = await getRecipeIngredients(item?.item_id);

      setIngredients(data || []);
    };

    if (item?.item_id) loadData();
  }, [item]);


  const handleChange = (index, field, value) => {
    const updated = [...formRows];
    updated[index][field] = value;
    setFormRows(updated);
  };

  const addRow = () => {
    setFormRows([...formRows, { name: "", qty: "", unit: "" }]);
  };

  const removeRow = (index) => {
    const updated = formRows.filter((_, i) => i !== index);
    setFormRows(updated);
  };

  const handleSubmit = async () => {
    const payload = {
      userid: userID,
      itemId: item?.item_id,
      ingredients: formRows.map((i) => ({
        ingredientName: i.name,
        quantity: i.qty,
        unit: i.unit,
      })),
    };

    const success = await addRecipeIngredient(payload);

    if (success) {
      const updatedData = await getRecipeIngredients(item?.item_id);

      setIngredients(updatedData || []);
      setFormRows([{ name: "", qty: "", unit: "" }]);
      setShowForm(false);
    }
  };

  return (
    <>
    
    <div className="p-6 min-h-screen montserrat-font-1">
      <div className="flex items-center gap-4 mb-6 montserrat-font-1">
        <img
          src={item?.photo}
          className="w-14 h-14 rounded-lg object-cover"
        />
        <div>
          <h2 className="text-lg font-semibold">{item?.item_name}</h2>
          <p className="text-sm text-gray-500">
            Item ID: {item?.item_id}
          </p>
        </div>
      </div>

      {!showForm && ingredients.length > 0 && (
        <div className="bg-white border rounded-lg p-4 mb-6 montserrat-font-1">
          <h3 className="font-semibold mb-3">Existing Ingredients</h3>

          <table className="w-full text-sm border montserrat-font-1">
            <thead className="bg-gray-100">
              <tr>
                <th className="p-2 border">#</th>
                <th className="p-2 border">Ingredient</th>
                <th className="p-2 border">Quantity</th>
                <th className="p-2 border">Unit</th>
                <th className="p-2 border">Actions</th>
              </tr>
            </thead>

            <tbody>
              {ingredients.map((ing, i) => (
                <tr key={i}>
                  <td className="p-2 border">{i + 1}</td>
                  <td className="p-2 border">
                    {ing.ingredient_name}
                  </td>
                  <td className="p-2 border">{ing.quantity}</td>
                  <td className="p-2 border">{ing.unit}</td>
                  <td className="p-2 border">
                    <button className="text-blue-600 mr-2">
                      Edit
                    </button>
                    <button className="text-red-500">
                      Remove
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* ADD MORE */}
          <div className="flex justify-end mt-4 montserrat-font-1">
            <button
              onClick={() => setShowForm(true)}
              className="bg-green-600 text-white px-4 py-2 rounded"
            >
              + Add More
            </button>
          </div>
        </div>
      )}

      {/* ================= EMPTY STATE ================= */}
      {!showForm && ingredients.length === 0 && (
        <div className="bg-white border rounded-lg p-6 text-center montserrat-font-1 text-gray-500 mb-6">
          <p>No ingredients found for this item.</p>
          <p className="text-sm mt-1">
            Please start by adding new ingredients below.
          </p>

          <button
            onClick={() => setShowForm(true)}
            className="mt-4 bg-green-600 text-white px-4 py-2 rounded"
          >
            Add Ingredients
          </button>
        </div>
      )}

      {/* ================= FORM ================= */}
      {showForm && (
        <div className="bg-white border rounded-lg p-4 montserrat-font-1">
          <h3 className="font-semibold mb-4">Add Ingredients</h3>

          {formRows.map((row, index) => (
            <div
              key={index}
              className="grid grid-cols-4 gap-4 mb-3"
            >
              {/* NAME */}
              <div>
                <label className="text-xs text-gray-500">
                  Ingredient
                </label>
                <input
                  type="text"
                  value={row.name}
                  onChange={(e) =>
                    handleChange(index, "name", e.target.value)
                  }
                  className="border rounded px-3 py-2 w-full text-sm"
                />
              </div>

              {/* QTY */}
              <div>
                <label className="text-xs text-gray-500">
                  Quantity
                </label>
                <input
                  type="number"
                  value={row.qty}
                  onChange={(e) =>
                    handleChange(index, "qty", e.target.value)
                  }
                  className="border rounded px-3 py-2 w-full text-sm"
                />
              </div>

              {/* UNIT */}
              <div>
                <label className="text-xs text-gray-500">
                  Unit
                </label>
                <input
                  type="text"
                  value={row.unit}
                  onChange={(e) =>
                    handleChange(index, "unit", e.target.value)
                  }
                  className="border rounded px-3 py-2 w-full text-sm"
                />
              </div>

              {/* REMOVE */}
              <div className="flex items-end">
                <button
                  onClick={() => removeRow(index)}
                  className="bg-red-500 text-white px-3 py-2 rounded w-full text-sm"
                >
                  Remove
                </button>
              </div>
            </div>
          ))}

          {/* ACTIONS */}
          <div className="flex gap-3 mt-4 montserrat-font-1">
            <button
              onClick={addRow}
              className="border px-4 py-2 rounded text-sm text-blue-600"
            >
              + Add Row
            </button>

            <button
              onClick={handleSubmit}
              className="bg-green-600 text-white px-4 py-2 rounded text-sm"
            >
              Submit
            </button>

            <button
              onClick={() => setShowForm(false)}
              className="border px-4 py-2 rounded text-sm"
            >
              Cancel
            </button>
          </div>
        </div>
      )}
    </div>
    </>
  );
};

export default IngredientsPage;